import { useTranslation } from "react-i18next";

const MAP_URL_FULL =
  "https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/etc/South_Korea_Vs30_half.png";
const MAP_URL_SMALL =
  "https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/etc/South_Korea_Vs30_5p.png";

export const SeismicDesignCategoryMap = () => {
  const { t } = useTranslation();
  return (
    <div className="container">
      <div className="sub-container">
        <div style={{ fontSize: "15px", marginBottom: "5px" }}>
          &nbsp;&nbsp;<i className="ion ion-md-help-circle-outline"></i>
          {t("page.seismic-design-category-map.desc")}
        </div>
        <div className="overflow-auto">
          <img
            src={MAP_URL_SMALL}
            alt="Seismic Design Category Map"
            style={{ maxWidth: "100%" }}
            title={t("page.seismic-design-category-map.imgTitle")}
            onClick={() => {
              window.open(MAP_URL_FULL);
            }}
          />
        </div>
      </div>
    </div>
  );
};
